module.exports = __webpack_public_path__ + "gs.svg?be91ab5cec857ad89839684a0f8171e9";